<!--
  统计
  lovi 2020-06-03
-->
<template>
  <div class="w100 bill-wrapper">
    <van-nav-bar
      :title="$t('common.statistics')"
      left-arrow
      @click-left="_back"
    >
    </van-nav-bar>
    <div class="content-wrapper record-scroll">
      <scroll ref="scroll">
        <div class="statistics-filter">
          <div class="date-time" @click="chooseDate">
            <span>{{ dateFormat(setDate) }}</span>
            <van-icon name="notes-o" />
          </div>
        </div>
        <div class="statistics-info">
          <div class="statistics-item" @click="changeChart(1)">
            <h3>{{ $t("common.totalExpenditure") }}</h3>
            <p>{{ total_expense }}</p>
          </div>
          <div class="statistics-item" @click="changeChart(2)">
            <h3>{{ $t("common.totalIncome") }}</h3>
            <p>{{ total_earning }}</p>
          </div>
        </div>
        <div class="statistics-box">
          <h3>
            {{ $t("common.daily") }}
            {{  $t("common.expenditure") }}
          </h3>
          <div ref="myEchart" class="statistics_chart"></div>
          <h3>
            {{ $t("common.daily") }}
            {{ $t("common.income") }}
          </h3>
          <div ref="myEchart2" class="statistics_chart"></div>
        </div>
      </scroll>
    </div>
    <van-popup v-model="dateShow" position="bottom" get-container="body">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        :max-date="maxDate"
        :formatter="formatter"
        @confirm="changeDate"
        @cancel="dateShow = false"
      />
    </van-popup>

    <tabbar />
  </div>
</template>

<script>
import echarts from "echarts";
import Tabbar from "./tabbar";
export default {
  name: "statistics",
  components: {
    Tabbar
  },
  data() {
    return {
      dateShow: false,
      setDate: new Date(),
      currentDate: new Date(),
      maxDate: new Date(),
      total_expense: 0, //总支出
      total_earning: 0, //总收入
      type: 1,
      xNum: [],
      series: [],
      xNum2: [],
      series2: []
    };
  },
  created() {
    let vm = this;
    vm.getStatistics();
  },
  mounted() {},
  computed: {},
  methods: {
    changeChart(type) {
      let vm = this;
      vm.type = type;
      vm.getStatistics();
    },
    initChart() {
      let vm = this;
      let myChart = echarts.init(vm.$refs.myEchart);
      myChart.setOption({
        tooltip: {
          trigger: "axis",
          padding: 10,
          backgroundColor: "#2042AB",
          formatter: function(params) {
            return params[0].name + "<br/>" + params[0].value[1] + "P";
          }
        },
        xAxis: {
          boundaryGap: false,
          type: "category",
          data: vm.xNum
        },
        yAxis: {
          type: "value",
          show: false
        },
        series: {
          type: "line",
          itemStyle: {
            normal: {
              color: "#2042AB",
              lineStyle: {
                color: "#2042AB"
              }
            }
          },
          data: vm.series
        }
      });

      // 默认显示
      setTimeout(function() {
        myChart.dispatchAction({
          type: "showTip",
          seriesIndex: 0, // 显示第几个series
          dataIndex: vm.series.length - 1 // 显示第几个数据
        });
      });
    },

    initChart2() {
      let vm = this;
      let myChart2 = echarts.init(vm.$refs.myEchart2);
      myChart2.setOption({
        tooltip: {
          trigger: "axis",
          padding: 10,
          backgroundColor: "#2042AB",
          formatter: function(params) {
            return params[0].name + "<br/>" + params[0].value[1] + "P";
          }
        },
        xAxis: {
          boundaryGap: false,
          type: "category",
          data: vm.xNum2
        },
        yAxis: {
          type: "value",
          show: false
        },
        series: {
          type: "line",
          itemStyle: {
            normal: {
              color: "#2042AB",
              lineStyle: {
                color: "#2042AB"
              }
            }
          },
          data: vm.series2
        }
      });

      // 默认显示
      setTimeout(function() {
        myChart.dispatchAction({
          type: "showTip",
          seriesIndex: 0, // 显示第几个series
          dataIndex: vm.series2.length - 1 // 显示第几个数据
        });
      });
    },

    chooseDate() {
      //选择日期
      let vm = this;
      vm.currentDate = vm.setDate;
      vm.dateShow = true;
    },
    changeDate(date) {
      //修改日期
      let vm = this;
      vm.setDate = date;
      vm.dateShow = false;
      vm.getStatistics();
    },
    getStatistics() {
      //账单统计
      let vm = this;
      let params = {};
      params.time = vm.dateFormat(vm.setDate);
      params.type = vm.type;
      vm.$post("/app/order/statistics", params, { loading: true }).then(res => {
        console.log("statistics", res);
        vm.total_expense = res.total_expense;
        vm.total_earning = res.total_earning;
        vm.xNum = [];
        vm.series = [];
        vm.xNum2 = [];
        vm.series2= [];
        res.list=res.out_list;
        for (let i = 0; i < res.list.length; i++) {
          let obj = {};
          obj.name = res.list[i].time;
          obj.value = [i, res.list[i].money.split("P")[0]];
          vm.series.push(obj);
          vm.xNum.push(res.list[i].title.substring(5));
        }
        res.list=res.in_list;
        for (let i = 0; i < res.list.length; i++) {
          let obj = {};
          obj.name = res.list[i].time;
          obj.value = [i, res.list[i].money.split("P")[0]];
          vm.series2.push(obj);
          vm.xNum2.push(res.list[i].title.substring(5));
        }
        vm.initChart();
        vm.initChart2();
      });
    },
    formatter(type, value) {
      if (type === "year") {
        return value + this.$t("common.year");
      } else if (type === "month") {
        return value + this.$t("common.month");
      }
      return value;
    },
    dateFormat(date) {
      let year = date.getFullYear();
      let month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      return year + "-" + month;
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.bill-wrapper {
  bottom: 51px !important;
}
.statistics-filter {
  height: 50px;
  padding: 0 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1.1px solid #e4e4e4;

  .date-time {
    min-width: 100px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #4a4a4a;
    background: #f0f2f5;
    border-radius: 3px;
    padding: 0 6px;

    span {
      font-size: 12px;
    }

    /deep/.van-icon {
      color: #4a4a4a;
      font-size: 16px;
    }
  }
}

.statistics-info {
  height: 85px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1.1px solid #e4e4e4;

  .statistics-item {
    flex: 1;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    h3 {
      font-size: 14px;
      font-weight: 500;
      color: #4a4a4a;
    }

    p {
      font-size: 20px;
      font-weight: 500;
      color: #4a4a4a;
    }
  }

  .statistics-item + .statistics-item {
    border-left: 1.1px solid #e4e4e4;
  }
}

.statistics-box {
  padding: 22px;

  h3 {
    font-size: 14px;
    color: #4a4a4a;
  }

  .statistics_chart {
    width: 100%;
    height: 250px;

    canvas {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
